import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const MessengerJobCancelled = () => {
    const navigate              = useNavigate();
    const { id: encodedId, refNo: encodedRefNo } = useParams();
    const refNo = encodedRefNo ? atob(encodedRefNo) : '-';

    return (
        <div className="mjcancel-root">
            <div className="mjcancel-content">
                <div className="mjcancel-icon">
                    <i className="mdi mdi-close-circle" />
                </div>
                <p className="mjcancel-title">งานถูกยกเลิก</p>
                <p className="mjcancel-ref">Ref No. {refNo}</p>
                <p className="mjcancel-sub">ถูกยกเลิกงาน ไม่ต้องส่งต่อ</p>
            </div>

            <div className="mjcancel-footer">
                <button
                    className="mjd-btn mjd-btn--primary"
                    onClick={() => navigate('/messenger/myjob', { replace: true })}
                >
                    รับทราบ
                </button>
            </div>
        </div>
    );
};

export default MessengerJobCancelled;